import Vue from 'vue'
import store from '@/shared/store'
//import loading from '@/shared/plugins/loading'

export const formataUrlBase = ((rota) => {
    if(Vue.prototype.$urlBase == undefined){
        Vue.prototype.$urlBase = ''
    }
    if(!Vue.prototype.$url) {
        Vue.prototype.$url = {
            module: '',
            controller: '',
            action: '',
        }
    } else {
        Vue.prototype.$url.module = ''
        Vue.prototype.$url.controller = ''
        Vue.prototype.$url.action = ''
    }
    const modules = require('@/modules/modules.json')
    const p1 = rota.split('?')
    const p2 = p1[0].split('/')
    let i = 1
    let moduleFound = false
    
    if(Array.isArray(modules)){
        // Separa submódulos e módulos normais, priorizando submódulos
        const submodules = modules.filter(m => m.includes(':'))
        const normalModules = modules.filter(m => !m.includes(':'))
        const orderedModules = [...submodules, ...normalModules]
        
        orderedModules.some(module => {
            // Se é um submódulo (formato "modulo:submodulo")
            if(module.includes(':')) {
                const [parentModule, submodule] = module.split(':')
                // Verifica se a URL corresponde: /parentModule/submodule/...
                if(p2[i] && p2[i] == parentModule && p2[i+1] && p2[i+1] == submodule) {
                    const externalModules = require('@/modules/external-modules.json')
                    Vue.prototype.$url.module = submodule
                    if(externalModules.filter(item => item == submodule).length == 0) {
                        Vue.prototype.$urlBase = '/' + parentModule + '/' + submodule
                    }
                    i += 2  // Avança 2 posições (módulo + submódulo)
                    
                    // Define controller e action para submódulos
                    if(p2[i]){
                        Vue.prototype.$url.controller = p2[i]   
                        i++   
                    }
                    if(p2[i]){
                        Vue.prototype.$url.action = p2[i]   
                        i++   
                    }
                    moduleFound = true
                    return true  // Para a iteração
                }
            } 
            // Módulo normal
            else if(p2[i] && p2[i] == module){
                const externalModules = require('@/modules/external-modules.json')
                Vue.prototype.$url.module = module
                if(externalModules.filter(item => item == module).length == 0) {
                    Vue.prototype.$urlBase = '/' + module
                }
                i++
                
                // Define controller e action para módulos normais
                if(p2[i]){
                    Vue.prototype.$url.controller = p2[i]   
                    i++   
                }
                if(p2[i]){
                    Vue.prototype.$url.action = p2[i]   
                    i++   
                }
                moduleFound = true
                return true  // Para a iteração
            }
            return false  // Continua iterando
        })  
    }
    
    // Fallback: se nenhum módulo foi encontrado, tenta definir controller e action
    if(!moduleFound) {
        if(p2[i]){
            Vue.prototype.$url.controller = p2[i]   
            i++   
        }
        if(p2[i]){
            Vue.prototype.$url.action = p2[i]   
            i++   
        }
    }
})

export const formataRotasGlobais = ((modulo, rotas) => {
    const prefixo = modulo ? '/' + modulo : ''
    const aplicaPrefixo = (valor) => {
        if (Array.isArray(valor)) return valor.map(aplicaPrefixo)
        if (typeof valor === 'string') return prefixo + valor
        return valor
    }
    return rotas.map((rota) => {
        const novaRota = { ...rota }
        if (rota.path) novaRota.path = aplicaPrefixo(rota.path)
        if (rota.alias) novaRota.alias = aplicaPrefixo(rota.alias)
        if (Array.isArray(rota.children)) {
            novaRota.children = rota.children.map((cRota) => {
                const novoFilho = { ...cRota }
                if (cRota.path) novoFilho.path = aplicaPrefixo(cRota.path)
                if (cRota.alias) novoFilho.alias = aplicaPrefixo(cRota.alias)
                if (cRota.redirect && typeof cRota.redirect === 'string') {
                    novoFilho.redirect = aplicaPrefixo(cRota.redirect)
                }
                return novoFilho
            })
        }
        return novaRota
    })
})

// Coleta e normaliza as rotas-filhas de um módulo a partir do require.context dos
// seus routes.js (ex.: require.context('../domains/', true, /routes.js$/i)).
// Remove a barra inicial de path/alias para que sejam tratados como relativos ao
// parent do módulo — assim cada routes.js funciona escrito COM ou SEM barra inicial.
export const formataRotasFilhas = ((contextoRotas) => {
    const tiraBarraInicial = (valor) => {
        if (Array.isArray(valor)) return valor.map(tiraBarraInicial)
        if (typeof valor === 'string') return valor.replace(/^\/+/, '')
        return valor
    }
    const normalizaRota = (rota) => {
        if (!rota) return rota
        const novaRota = { ...rota }
        if (novaRota.path) novaRota.path = tiraBarraInicial(novaRota.path)
        if (novaRota.alias) novaRota.alias = tiraBarraInicial(novaRota.alias)
        if (Array.isArray(novaRota.children)) {
            novaRota.children = novaRota.children.map(normalizaRota)
        }
        return novaRota
    }
    return contextoRotas.keys()
        .map(contextoRotas)
        .map((modulo) => modulo.default)
        .filter(Array.isArray)
        .flatMap((rotas) => rotas.map(normalizaRota))
})

export const formataUrlRedirecionamento = ((redirecionamento) => {
    let retorno = '/'
    if(redirecionamento.constructor.name === 'String'){
        retorno = redirecionamento
    }else{
        retorno = Vue.prototype.$urlBase + '/'
        retorno += redirecionamento.controller || Vue.prototype.$url.controller
        retorno += '/'
        retorno += redirecionamento.action || Vue.prototype.$url.action
        Object.keys(redirecionamento).map(parametro => {
            if(
                !['plugin', 'controller', 'action', '?'].includes(parametro)
                &&
                isNaN(parametro)
            ){
                retorno += '/'
                retorno += parametro
                retorno += ':'
                retorno += redirecionamento[parametro]
            }
        })
        if(redirecionamento[0]){
            retorno += '/'
            retorno += redirecionamento[0]
        }
        // GCK-20560: quando o redirecionamento vem sem `controller` (ex.: 402 disparado na
        // home do modulo, onde $url.controller e vazio) a concatenacao gerava barra dupla no
        // path — `/controle_producao//index`, que cai no catch-all do vue-router. Normaliza
        // so o path (antes da query) e preserva `://` de URL absoluta.
        retorno = retorno.replace(/(^|[^:])\/{2,}/g, '$1/')
        if(redirecionamento['?']){
            retorno += '?'
            Object.keys(redirecionamento['?']).map((parametro, i) => {
                if(i > 0){
                    retorno += '&'
                }
                retorno += parametro 
                retorno += '=' 
                retorno += redirecionamento['?'][parametro]
            })
        }
    }
    retorno = retorno.replace(window.location.origin, '')
    return retorno
})

export const formataRotasSubmodulos = ((contextoSubmodulos, modulo) => {
    const normalizaString = (valor, submodulo) => {
        if (valor == null) return valor
        if (typeof valor !== 'string') return valor
        if (!valor || valor === '/') return `/${modulo}/${submodulo}`
        const comBarra = valor.startsWith('/') ? valor : `/${valor}`
        if (comBarra.startsWith(`/${modulo}/`)) return comBarra
        // só trata como "já prefixado com o submódulo" se for exatamente /sub ou /sub/...
        // (evita comer o segmento em paths como /vendas_produtos, que começa com /vendas)
        if (comBarra === `/${submodulo}` || comBarra.startsWith(`/${submodulo}/`)) return `/${modulo}${comBarra}`
        return `/${modulo}/${submodulo}${comBarra}`
    }

    const normalizaValor = (valor, submodulo) => Array.isArray(valor)
        ? valor.map(item => normalizaString(item, submodulo)).filter(item => item != null)
        : normalizaString(valor, submodulo)

    const garanteAliasIndex = (alias, caminho) => {
        if (!caminho || Array.isArray(caminho)) return alias
        const lista = alias ? (Array.isArray(alias) ? [...alias] : [alias]) : []
        const aliasIndex = `${caminho.replace(/\/$/, '')}/index`
        if (!lista.includes(aliasIndex)) lista.push(aliasIndex)
        if (lista.length === 0) return undefined
        if (lista.length === 1) return lista[0]
        return lista
    }

    const normalizaRota = (rota, submodulo) => {
        if (!rota) return rota
        const novaRota = { ...rota }
        novaRota.path = normalizaValor(rota.path, submodulo)
        novaRota.alias = garanteAliasIndex(normalizaValor(rota.alias, submodulo), novaRota.path)
        novaRota.redirect = normalizaValor(rota.redirect, submodulo)
        if (Array.isArray(rota.children)) {
            novaRota.children = rota.children.map(filho => normalizaRota(filho, submodulo))
        }
        return novaRota
    }

    return contextoSubmodulos.keys().flatMap(chave => {
        const submodulo = chave.split('/')[1]
        const rotas = contextoSubmodulos(chave).routes || []
        return rotas.map(rota => normalizaRota(rota, submodulo))
    })
})

export const validaSite = async () => {
    const retorno = await store._modules.root.context.dispatch('dominios/carregaDominio')
    if (retorno.status == 'success' && retorno.data.Dominio.possui_site == 1) {
        return true
    }
    return false
}